<!--
<mat-chip-set class="d-flex">
  <mat-chip-option [matTooltip]="recentProperty.id + ''"
    class="clickable ellipsis chip mat-elevation-z2"
    (click)="selectProperty(recentProperty)"
    *ngFor="let recentProperty of propertyService.recentInfo | async | slice:0:limit"
    selected
    [color]="'primary'"
    [ngClass]="{ 'highlighted': isHighlighted(recentProperty) }"
  >
    {{ recentProperty | propSummaryName: 40 }}
  </mat-chip-option>
</mat-chip-set>-->

<div class="d-flex flex-wrap">
  <app-button-tag
    class="m-1"
    *ngFor="let recentProperty of propertyService.recentInfo | async | slice:0:limit"
    (itemClick)="selectProperty(recentProperty)"
    [highlighted]="isHighlighted(recentProperty)"
    [matTooltip]="recentProperty.id + ''"
    icon="settings_accessibility"
    [label]="recentProperty | propSummaryName: 40"
    [color]="primaryColor">
  </app-button-tag>
</div>


